import i18n from "i18next";

export function columnsCountries() {
  return [
    {
      id: "label",
      label: i18n.t("column.country"),
      minWidth: 150,
      maxWidth: 220,
      align: "left",
    },
    {
      id: "value",
      label: i18n.t("column.iso_code_alpha2"),
      minWidth: 40,
      maxWidth: 130,
      align: "left",
    },
    {
      id: "value_iso3",
      label: i18n.t("column.iso_code_alpha3"),
      minWidth: 40,
      maxWidth: 130,
      align: "left",
    },
    {
      id: "value_numeric",
      label: i18n.t("column.iso_code_numeric"),
      minWidth: 40,
      maxWidth: 130,
      align: "left",
    },
  ];
}
